module.exports = __webpack_public_path__ + "img/Batgirl.49ec2795.jpg";